export const NoPlans = () => {
    return (
        <div className="text-center pt-4 pb-4">
            <i className="bx bx-search-alt fs-24 text-muted" />
            <h5 className="mt-2 text-muted">No Plans Posted</h5>
        </div>
    )
}